import { render, staticRenderFns } from "./ListItemCateV2.vue?vue&type=template&id=489cf7b8&scoped=true"
import script from "./ListItemCateV2.vue?vue&type=script&lang=js"
export * from "./ListItemCateV2.vue?vue&type=script&lang=js"
import style0 from "./ListItemCateV2.vue?vue&type=style&index=0&id=489cf7b8&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489cf7b8",
  null
  
)

export default component.exports